import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FicheConseilFilterInput, FicheConseilState } from '@lib/models/generated/graphql';
import { OuiButtonToggleOption } from 'omnium-ui/button-toggle';
import { distinctUntilChanged } from 'rxjs';
const NOT_DONE_FILTER: FicheConseilFilterInput = { statut: { neq: FicheConseilState.ConseilDone } };
const DONE_ONLY_FILTER: FicheConseilFilterInput = { statut: { eq: FicheConseilState.ConseilDone } };
@Component({
  selector: 'app-fiche-conseil-state-toggle-selector',
  templateUrl: './fiche-conseil-state-toggle-selector.component.html',
  styleUrls: ['./fiche-conseil-state-toggle-selector.component.scss'],
})
export class FicheConseilStateToggleSelectorComponent {
  @Output() filterChange = new EventEmitter<FicheConseilFilterInput | null>();

  formControl = new FormControl<FicheConseilFilterInput | null>(null);
  options: OuiButtonToggleOption<FicheConseilFilterInput | null>[] = [
    { value: null, label: 'Toutes' },
    { value: NOT_DONE_FILTER, label: 'Brouillon' },
    { value: DONE_ONLY_FILTER, label: 'Terminé' },
  ];
  shout = false;
  constructor() {}
  ngOnInit() {
    this.formControl.valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      // prevent to emit the default value on init
      if (this.shout) {
        this.filterChange.emit(value);
      }
      this.shout = true;
    });
  }
}
